import { useTranslation } from "react-i18next";
import Seo from "../../components/Seo/Seo";
import "./Management.css";

export default function Board() {
  const { t } = useTranslation("common");

  // Board members configuration
  const boardMembers = [
    {
      name: t("mgmt.board.members.0.name"),
      role: t("mgmt.board.members.0.role"),
      photo: "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/wdorjbls6veuzfjuxxxq.svg",
      phone: "",
      linkedin: "",
      email: ""
    },
    {
      name: t("mgmt.board.members.1.name"),
      role: t("mgmt.board.members.1.role"),
      photo: "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/jw1ioprzbd6eydlyecny.svg",
      phone: "",
      linkedin: "",
      email: ""
    },
    {
      name: t("mgmt.board.members.2.name"),
      role: t("mgmt.board.members.2.role"),
      photo: "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/z4coi9xyqyme2cthkawr.svg",
      phone: "",
      linkedin: "",
      email: ""
    },
    {
      name: t("mgmt.board.members.3.name"),
      role: t("mgmt.board.members.3.role"),
      photo: "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/jhuwlcfjcdeti471d09j.svg",
      phone: "",
      linkedin: "",
      email: ""
    },
    {
      name: t("mgmt.board.members.4.name"),
      role: t("mgmt.board.members.4.role"),
      photo: "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/uenisp0qcochit56ptb6.svg",
      phone: "",
      linkedin: "",
      email: ""
    }
  ];

  return (
    <section className="page">
      <Seo title={t("seo.board.title")} description={t("seo.board.desc")} path="/management/board" />

      <div className="container">
        <div className="pageHead">
          <h1>{t("mgmt.board.t.board")}</h1>
          <p className="muted">{t("mgmt.boardDesc")}</p>
        </div>

        <div className="boardGrid">
          {boardMembers.map((member, index) => (
            <div className={`boardCard ${index < 3 ? 'boardCard--featured' : ''}`} key={index}>
              <div className="boardCard__imageWrapper">
                <img 
                  src={member.photo} 
                  alt={member.name}
                  className="boardCard__image"
                />
                <div className="boardCard__overlay">
                  <div className="boardCard__socialLinks">
                    {member.linkedin && (
                      <a 
                        href={member.linkedin} 
                        className="socialLink" 
                        aria-label="LinkedIn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14m-.5 15.5v-5.3a3.26 3.26 0 00-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 011.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 001.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 00-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                        </svg>
                      </a>
                    )}
                    {member.email && (
                      <a 
                        href={`mailto:${member.email}`} 
                        className="socialLink" 
                        aria-label="Email"
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                        </svg>
                      </a>
                    )}
                    {member.phone && (
                      <a 
                        href={`tel:${member.phone}`} 
                        className="socialLink" 
                        aria-label="Phone"
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="boardCard__content">
                <div className="boardCard__role">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                  <span>{member.role}</span>
                </div>
                <h3 className="boardCard__name">{member.name}</h3>
                <div className="boardCard__divider"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}